/**
 * 1、在标绘对象上面附加一个attr对象
 * 2、实现attr对象和style糊状
 * 3、材质重构
 *    materialType //String
 *    materialOption //Object
 */
let commonNorProperties = ["zIndex", "stRotation", "width", "clampToGround", "pixelSize", "color", "outline", "outlineColor", "outlineWidth", "text", "scale", "showBackground", "backgroundColor", "fillColor", "show", "image", "rotation", "height", "extrudedHeight", "length", "minimumHeights", "maximumHeights"];

let commonSpecialProperties = ["imageUrl","font", "fontName", "fontSize", "backgroundPadding", "backgroundPaddingX", "backgroundPaddingY", "pixelOffset", "pixelOffsetX", "pixelOffsetY"];
class StyleUtil {

    static deletePlot(entity) {

        if (entity.attrPlot && entity.attrPlot["edit_keyPos"]) {
            let entities = entity.attrPlot["edit_keyPos"];
            for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
            }
        }

        if (entity.attrPlot && entity.attrPlot["edit_center"]) {
            let entities = [entity.attrPlot["edit_center"]];
            for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
            }
        }

        if (entity.attrPlot && entity.attrPlot["edit_rotation"]) {
            let entities = [entity.attrPlot["edit_rotation"]];
            for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
            }
        }

        if (entity.attrPlot && entity.attrPlot["edit_height"]) {
            let entities = [entity.attrPlot["edit_height"]];
            for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
            }
        }

        viewer.entities.remove(entity); //自身
    }


    static hidePlot(entity) {

        if (entity.attrPlot && entity.attrPlot["edit_keyPos"]) {
            let entities = entity.attrPlot["edit_keyPos"];
            for (let i = 0; i < entities.length; i++) {
                entities[i].show = false;
            }
        }

        if (entity.attrPlot && entity.attrPlot["edit_center"]) {
            let entities = [entity.attrPlot["edit_center"]];
            for (let i = 0; i < entities.length; i++) {
                entities[i].show = false;
            }
        }

        if (entity.attrPlot && entity.attrPlot["edit_rotation"]) {
            let entities = [entity.attrPlot["edit_rotation"]];
            for (let i = 0; i < entities.length; i++) {
                entities[i].show = false;
            }
        }

        if (entity.attrPlot && entity.attrPlot["edit_height"]) {
            let entities = [entity.attrPlot["edit_height"]];
            for (let i = 0; i < entities.length; i++) {
                entities[i].show = false;
            }
        }
    }
    static getNorProperties() {

        return commonNorProperties;
    }

    //提取实体样式
    static getEntity2Style(formSet, entity, type) {
        let style = JSON.parse(JSON.stringify(formSet));
        entity[type]["attr"] = entity[type]["attr"] || {};
        //通用属性
        commonNorProperties.forEach(property => {
            if (entity[type][property] || entity[type][property] === false || entity[type][property] === 0) {
                style[property] = StyleUtil.getValue(property, entity[type][property]);
            }
        });

        commonSpecialProperties.forEach(property => {
            if (entity[type][property] || entity[type][property] === false || entity[type][property] === 0) {
                var value = entity[type][property];
                if (typeof value.getValue == 'function') {
                    value = value.getValue();
                }
                if (property == "font") {

                    //'30px sans-serif'
                    var valueArr = value.split(" ");
                    var fontSize = Number(valueArr[0].split("px")[0]);
                    style["fontSize"] = fontSize;
                    style["fontName"] = valueArr[1];
                }

                if (property == "backgroundPadding") {
                    style["backgroundPaddingX"] = value.x;
                    style["backgroundPaddingY"] = value.y;
                }
                if (property == "pixelOffset") {
                    style["pixelOffsetX"] = value.x;
                    style["pixelOffsetY"] = value.y;
                }

                if (property == "imageUrl") {
                    style["imageUrl"] = value
                }

            }
        });

        //有缓存直接使用缓存//entity[type]["cache"]leix
        if (style.materialType && entity[type]["cache"] && entity[type]["cache"][style.materialType]) {
            style["materialOption"] = entity[type]["cache"][style.materialType]
            return style;
        }

        //无缓存则计算出来
        if (style["materialType"] && entity[type].material) {
            style["materialOption"] = StyleUtil.getMaterialOptionByType(style["materialType"], entity[type].material);
        }

        //处理svg文件
        if (formSet && formSet.image && formSet.image.startsWith("blobJB:")) {
            style.image = formSet.image;
        }

        return style;
    }


    //设置样式给实体
    static setStyle2Entity(formSet, entity, type) {
        if (!formSet.materialOption) {
            return
        }
        let style = JSON.parse(JSON.stringify(formSet));
        entity[type]["cache"] = entity[type]["cache"] || {}; //缓存样式
        entity[type]["attr"] = JSON.parse(JSON.stringify(style)); //存储样式
        var material = StyleUtil.getMaterialByType(style.materialType, style.materialOption);
        entity[type].material = material; //材质

        commonNorProperties.forEach(property => {
            //if ((style[property] && entity[type][property]) || style[property] === false || style[property] === 0) {
            if ((style[property] && entity[type]) || style[property] === false || style[property] === 0) {
                if ((style[property] && entity[type][property]) && entity[type][property].setValue) {
                    let res = StyleUtil.setValue(property, style[property]);

                    if (property != "minimumHeights" && property != "maximumHeights") {
                        entity[type][property].setValue(res);
                    }
                }
                else {
                    if (property != "minimumHeights" && property != "maximumHeights") {
                        entity[type][property] = StyleUtil.setValue(property, style[property]);
                    }
                }
            }
        });

        commonSpecialProperties.forEach(property => {
            if (style[property] || style[property] === 0) {
                if (property == "fontSize") {
                    var fontSize = style["fontSize"];
                    var fontName = style["fontName"];
                    entity[type]["font"] = `${fontSize}px ${fontName}`;
                }
                if (property == "fontName") {
                    var fontSize = style["fontSize"];
                    var fontName = style["fontName"];
                    entity[type]["font"] = `${fontSize}px ${fontName}`;
                }

                if (property == "backgroundPaddingX") {
                    var x = style["backgroundPaddingX"];
                    var y = style["backgroundPaddingY"];
                    entity[type]["backgroundPadding"] = new Cesium.Cartesian2(x, y);
                }
                if (property == "backgroundPaddingY") {
                    var x = style["backgroundPaddingX"];
                    var y = style["backgroundPaddingY"];
                    entity[type]["backgroundPadding"] = new Cesium.Cartesian2(x, y);
                }

                if (property == "pixelOffsetX") {
                    var x = style["pixelOffsetX"];
                    var y = style["pixelOffsetY"];
                    entity[type]["pixelOffset"] = new Cesium.Cartesian2(x, y);
                }
                if (property == "pixelOffsetY") {
                    var x = style["pixelOffsetX"];
                    var y = style["pixelOffsetY"];
                    entity[type]["pixelOffset"] = new Cesium.Cartesian2(x, y);
                }

                if (property == "imageUrl") {
                    let value = style["imageUrl"];
                    if (value && value.startsWith("blobJB:")) {
                        let svgString = value.split("blobJB:")[1];
                        // 创建Blob对象
                        const blob = new Blob([svgString], { type: 'image/svg+xml' });
                        // 创建URL
                        let res = URL.createObjectURL(blob);
                        entity[type]["image"] = res;
                        entity[type]["imageUrl"] = value; //备份
                    }
                }
            }
        });

        entity[type]["cache"][style.materialType] = style.materialOption;
    }

    //stRotation
    static setValue(property, value) {
        let res;
        switch (property) {
            case "stRotation":
            case "rotation":
                res = Cesium.Math.toRadians(value);
                break;
            case "color":
            case "outlineColor":
            case "backgroundColor":
            case "fillColor":
                res = Cesium.Color.fromCssColorString(value);
                break;
            // case "image":
            //     if (value && value.startsWith("blobJB:")) {
            //         let svgString = value.split("blobJB:")[1];
            //         // 创建Blob对象
            //         const blob = new Blob([svgString], { type: 'image/svg+xml' });
            //         // 创建URL
            //         res = URL.createObjectURL(blob);
            //     }
            //     else {
            //         res = value;
            //     }
            //     break;
            default:
                res = value;
                break;
        }

        return res
    }

    //entity[type][property].getValue
    static getValue(property, value) {
        let res;
        if (typeof value.getValue == 'function') {
            value = value.getValue();
        }
        switch (property) {
            case "stRotation":
            case "rotation":
                res = Cesium.Math.toDegrees(value);
                break;
            case "color":
            case "outlineColor":
            case "backgroundColor":
            case "fillColor":
                res = value.toCssColorString()
                break;
            default:
                res = value;
                break;
        }

        return res
    }

    static getLineTypes() {

        return [

            {
                value: "ColorMaterialProperty",
                label: "实线"
            },
            {
                value: "PolylineOutlineMaterialProperty",
                label: "衬色线"
            },
            {
                value: "PolylineDashMaterialProperty",
                label: "虚线"
            },
            {
                value: "PolylineArrowMaterialProperty",
                label: "箭头线"
            },
            {
                value: "PolylineGlowMaterialProperty",
                label: "光晕线"
            },
            {
                value: "SatelliteMaterialProperty",
                label: "OD线"
            },
            // {
            //     value: "flicker_line",
            //     label: "闪烁线"
            // },
            // {
            //     value: "path_line",
            //     label: "轨迹线"
            // }
        ];
    }

    static getPolygonTypes() {

        return [
            {
                value: "ColorMaterialProperty",
                label: "纯色"
            },
            {
                value: "ImageMaterialProperty",
                label: "图片"
            },
            {
                value: "GridMaterialProperty",
                label: "网格"
            },
            {
                value: "StripeMaterialProperty",
                label: "条纹"
            },
            {
                value: "CheckerboardMaterialProperty",
                label: "棋盘"
            },
            {
                value: "TextImageMaterialProperty",
                label: "文本"
            },
            {
                value: "DynamicCircleBMaterialProperty",
                label: "扩散"
            },
            // {
            //     value: "flicker_line",
            //     label: "渐变"
            // },
            // {
            //     value: "path_line",
            //     label: "水面"
            // }
        ];
    }


    static getEllipsoidTypes() {

        return [
            {
                value: "ColorMaterialProperty",
                label: "纯色"
            },
            {
                value: "GridMaterialProperty",
                label: "网格"
            },
            {
                value: "StripeMaterialProperty",
                label: "条纹"
            },
            {
                value: "CheckerboardMaterialProperty",
                label: "棋盘"
            },
        ];
    }

    //根据材质类型获取材质参数
    static getMaterialOptionByType(materialType, material) {
        let materialOption = new Object();
        let value = material.getValue();
        switch (materialType) {
            //扩散
            case "DynamicCircleBMaterialProperty":
                var color = value.color.toCssColorString();
                var time = value.time || 10;
                materialOption.color = color;
                materialOption.time = time;
                break;
            //纯色
            case "ColorMaterialProperty":
                var color = value.color.toCssColorString();
                materialOption.color = color;
                break;
            //图片
            case "ImageMaterialProperty":
                var image = value.image;
                var repeat = value.repeat || {};
                var repeatX = repeat.x || 1.0;
                var repeatY = repeat.y || 1.0;
                var color;
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }
                var transparent = value.transparent || true;
                materialOption.color = color || "rgba(255, 255, 255, 1)";
                materialOption.image = image;
                materialOption.repeatX = repeatX;
                materialOption.repeatY = repeatY;
                materialOption.transparent = transparent;
                break;
            //网格
            case "GridMaterialProperty":
                var color;
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }
                var cellAlpha = value.cellAlpha;
                var lineCount = value.lineCount || {};
                var lineThickness = value.lineThickness || {};
                var lineOffset = value.lineOffset || {};
                materialOption.color = color;
                materialOption.cellAlpha = cellAlpha || 0.1;
                materialOption.lineCount = lineCount.x || 8;
                materialOption.lineThickness = lineThickness.x || 1.0;
                materialOption.lineOffset = lineOffset.x || 0.0;
                break;
            //条纹
            case "StripeMaterialProperty":
                var evenColor = "#000000"
                if (value.evenColor && value.evenColor.toCssColorString) {
                    evenColor = value.evenColor.toCssColorString();
                }

                var oddColor = "#ffffff";
                if (value.oddColor && value.oddColor.toCssColorString) {
                    oddColor = value.oddColor.toCssColorString();
                }
                var repeat = value.repeat || 20;
                materialOption.evenColor = evenColor;
                materialOption.oddColor = oddColor;
                materialOption.repeat = repeat;
                break;
            //棋盘
            case "CheckerboardMaterialProperty":
                var evenColor = "#000000"
                if (value.evenColor && value.evenColor.toCssColorString) {
                    evenColor = value.evenColor.toCssColorString();
                }

                var oddColor = "#ffffff";
                if (value.oddColor && value.oddColor.toCssColorString) {
                    oddColor = value.oddColor.toCssColorString();
                }
                var repeat = value.repeat || 20;
                materialOption.evenColor = evenColor;
                materialOption.oddColor = oddColor;
                materialOption.repeat = repeat;
                break;
            //文本
            case "TextImageMaterialProperty":
                let attr = material.attr || {};
                materialOption.text = attr.text || "文本";
                materialOption.fillColor = attr.fillColor || "#ffffff";
                materialOption.fontSize = attr.fontSize || "100";
                materialOption.padding = attr.padding || "100";
                materialOption.hasBackground = attr.hasBackground || false;
                materialOption.backgroundColor = attr.backgroundColor || "#ffffff";
                break;

            //衬色线
            case "PolylineOutlineMaterialProperty":
                var color = "#ff0000"
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }

                var outlineColor = "#ffffff";
                if (value.outlineColor && value.outlineColor.toCssColorString) {
                    outlineColor = value.outlineColor.toCssColorString();
                }
                var outlineWidth = value.outlineWidth || 1.0;
                materialOption.color = color;
                materialOption.outlineColor = outlineColor;
                materialOption.outlineWidth = outlineWidth; //outlineWidth
                break;

            //虚线
            case "PolylineDashMaterialProperty":
                var color = "#ff0000"
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }

                var gapColor = "#ffffff";
                if (value.gapColor && value.gapColor.toCssColorString) {
                    gapColor = value.gapColor.toCssColorString();
                }
                var dashLength = value.dashLength || 16.0;
                materialOption.color = color;
                materialOption.gapColor = gapColor;
                materialOption.dashLength = dashLength; //
                break;

            case "PolylineArrowMaterialProperty":
                var color = "#ff0000"
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }
                materialOption.color = color;
                break;

            case "PolylineGlowMaterialProperty":
                var color = "#ffffff"
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }

                var glowPower = value.glowPower || 0.25;
                var taperPower = value.taperPower || 1.0;

                materialOption.color = color;
                materialOption.glowPower = glowPower;
                materialOption.taperPower = taperPower; //
                break;
            //OD线
            case "SatelliteMaterialProperty":
                var color = "#ff0000"
                if (value.color && value.color.toCssColorString) {
                    color = value.color.toCssColorString();
                }

                var backgroundColor = "#ffffff"
                if (value.backgroundColor && value.backgroundColor.toCssColorString) {
                    backgroundColor = value.backgroundColor.toCssColorString();
                }

                var speed = value.speed || 30.0;
                var gradient = value.gradient || 0.2;
                var count = value.count || 15;

                materialOption.backgroundColor = backgroundColor;
                materialOption.color = color;
                materialOption.speed = speed;
                materialOption.gradient = gradient; //
                materialOption.count = count; //
                break;
        }

        return materialOption;
    }


    //根据材质类型获取材质
    static getMaterialByType(materialType, materialOption) {

        let material;

        switch (materialType) {
            case "DynamicCircleBMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ffffff");
                color = Cesium.Color.fromCssColorString(color);
                var time = Cesium.defaultValue(materialOption["time"], 10);
                material = new Cesium.DynamicCircleBMaterialProperty({
                    color: color,
                    time: time
                });
                break;
            //纯色
            case "ColorMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ffffff");
                color = Cesium.Color.fromCssColorString(color);
                material = new Cesium.ColorMaterialProperty(color);
                break;
            //图片
            case "ImageMaterialProperty":
                var image = materialOption["image"];
                var repeatX = Cesium.defaultValue(materialOption["repeatX"], 1.0);
                var repeatY = Cesium.defaultValue(materialOption["repeatY"], 1.0);
                var repeat = new Cesium.Cartesian2(repeatX, repeatY)
                var color = Cesium.defaultValue(materialOption["color"], "#ffffff");
                color = Cesium.Color.fromCssColorString(color);
                var transparent = Cesium.defaultValue(materialOption["transparent"], true);
                if (image && image.startsWith("blobJB:")) {
                    let svgString = image.split("blobJB:")[1];
                    // 创建Blob对象
                    const blob = new Blob([svgString], { type: 'image/svg+xml' });
                    // 创建URL
                    image = URL.createObjectURL(blob);
                }
                material = new Cesium.ImageMaterialProperty({
                    image: image,
                    repeat: repeat,
                    color: color,
                    transparent: transparent
                });
                break;
            //网格
            case "GridMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ffffff");
                color = Cesium.Color.fromCssColorString(color);
                var cellAlpha = Cesium.defaultValue(materialOption["cellAlpha"], 0.1);
                var lineCount = Cesium.defaultValue(materialOption["lineCount"], 8);
                var lineThickness = Cesium.defaultValue(materialOption["lineThickness"], 1.0);
                var lineOffset = Cesium.defaultValue(materialOption["lineOffset"], 0.0);
                material = new Cesium.GridMaterialProperty({
                    color: color,
                    cellAlpha: cellAlpha,
                    lineCount: new Cesium.Cartesian2(lineCount, lineCount),
                    lineThickness: new Cesium.Cartesian2(lineThickness, lineThickness),
                    lineOffset: new Cesium.Cartesian2(lineOffset, lineOffset)
                });
                break;
            //条纹
            case "StripeMaterialProperty":
                var evenColor = materialOption["evenColor"];
                evenColor = new Cesium.Color.fromCssColorString(evenColor || "#000000")
                var oddColor = materialOption["oddColor"];
                oddColor = new Cesium.Color.fromCssColorString(oddColor || "#ffffff");
                var repeat = Cesium.defaultValue(materialOption["repeat"], 10);
                material = new Cesium.StripeMaterialProperty({
                    evenColor: evenColor,
                    oddColor: oddColor,
                    offset: 0,
                    repeat: repeat,
                });
                break;
            //棋盘
            case "CheckerboardMaterialProperty":
                var evenColor = materialOption["evenColor"];
                evenColor = new Cesium.Color.fromCssColorString(evenColor || "#000000")
                var oddColor = materialOption["oddColor"];
                oddColor = new Cesium.Color.fromCssColorString(oddColor || "#ffffff");
                var repeat = Cesium.defaultValue(materialOption["repeat"], 10);
                material = new Cesium.CheckerboardMaterialProperty({
                    evenColor: evenColor,
                    oddColor: oddColor,
                    repeat: new Cesium.Cartesian2(repeat, repeat),
                });
                break;
            //文本
            case "TextImageMaterialProperty":
                var text = Cesium.defaultValue(materialOption["text"], "文本");
                var fillColor = Cesium.defaultValue(materialOption["fillColor"], "#ffffff");
                fillColor = new Cesium.Color.fromCssColorString(fillColor);
                var fontSize = Cesium.defaultValue(materialOption["fontSize"], 100);
                var padding = Cesium.defaultValue(materialOption["padding"], 100);
                var hasBackground = Cesium.defaultValue(materialOption["hasBackground"], false);
                var backgroundColor = Cesium.defaultValue(materialOption["backgroundColor"], "#ffffff");
                backgroundColor = new Cesium.Color.fromCssColorString(backgroundColor);
                backgroundColor = hasBackground ? backgroundColor : Cesium.Color.TRANSPARENT;
                var canvas = StyleUtil.createTextCanvas(text, {
                    fillColor: fillColor,
                    fontSize: fontSize,
                    padding: padding,
                    backgroundColor: backgroundColor
                });
                material = new Cesium.ImageMaterialProperty({
                    image: canvas
                });
                material.attr = materialOption;
                break;

            //衬色线
            case "PolylineOutlineMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ff0000");
                color = new Cesium.Color.fromCssColorString(color);
                var outlineColor = Cesium.defaultValue(materialOption["outlineColor"], "#ffffff");
                outlineColor = new Cesium.Color.fromCssColorString(outlineColor);
                var outlineWidth = Cesium.defaultValue(materialOption["outlineWidth"], 1.0);

                material = new Cesium.PolylineOutlineMaterialProperty({
                    color: color,
                    outlineColor: outlineColor,
                    outlineWidth: outlineWidth
                });
                break;
            //虚线
            case "PolylineDashMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ff0000");
                color = new Cesium.Color.fromCssColorString(color);
                var gapColor = Cesium.defaultValue(materialOption["gapColor"], "#ffffff");
                gapColor = new Cesium.Color.fromCssColorString(gapColor);
                var dashLength = Cesium.defaultValue(materialOption["dashLength"], 16.0);

                material = new Cesium.PolylineDashMaterialProperty({
                    color: color,
                    gapColor: gapColor,
                    dashLength: dashLength,
                    dashPattern: 255.0
                });
                break;

            case "PolylineArrowMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ff0000");
                color = new Cesium.Color.fromCssColorString(color);
                material = new Cesium.PolylineArrowMaterialProperty(color);
                break;

            case "PolylineGlowMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ffffff");
                color = new Cesium.Color.fromCssColorString(color);

                var glowPower = Cesium.defaultValue(materialOption["glowPower"], 0.25);
                var taperPower = Cesium.defaultValue(materialOption["taperPower"], 1.0);

                material = new Cesium.PolylineGlowMaterialProperty({
                    color: color,
                    glowPower: glowPower,
                    taperPower: taperPower
                });
                break;

            //OD线
            case "SatelliteMaterialProperty":
                var color = Cesium.defaultValue(materialOption["color"], "#ff0000");
                color = new Cesium.Color.fromCssColorString(color);

                var backgroundColor = Cesium.defaultValue(materialOption["backgroundColor"], "#ffffff");
                backgroundColor = new Cesium.Color.fromCssColorString(backgroundColor);

                var speed = Cesium.defaultValue(materialOption["speed"], 30.0);
                var gradient = Cesium.defaultValue(materialOption["gradient"], 0.2);
                var count = Cesium.defaultValue(materialOption["count"], 15);

                material = new Cesium.SatelliteMaterialProperty({
                    backgroundColor: backgroundColor,
                    color: color,
                    speed: speed,
                    gradient: gradient,
                    count: count
                });
                break;
        }

        return material;

    }

    static createTextCanvas(text, options) {
        var canvas = Cesium.writeTextToCanvas(text, {
            font: `${options.fontSize}px sans-serif`,
            textBaseline: 'bottom',
            fill: true,
            stroke: false,
            fillColor: options.fillColor,
            strokeColor: Cesium.Color.BLACK,
            strokeWidth: 1,
            backgroundColor: options.backgroundColor,
            padding: options.padding,
        })
        return canvas;
    }

    //判断是否贴地
    static checkIsClampToGround(entity, type) {
        let clampToGround = true;
        let geometry = entity[type];
        switch (type) {
            case "polygon":
                clampToGround = geometry.heightReference == Cesium.HeightReference.CLAMP_TO_GROUND;
                break;
            case "polyline":
                clampToGround = geometry.clampToGround.getValue();
        }

        return clampToGround;

    }
}


export default StyleUtil;